function buildResponse(error, description) {
  return {
    error: error,
    errorDescription: description
  };
}

function invalidToken(description) {
  return buildResponse('invalid_token', description);
}

module.exports = {
  buildResponse: buildResponse,
  invalidToken: invalidToken
};



//////////////////
// WEBPACK FOOTER
// ./src/helper/error.js
// module id = 26
// module chunks = 0